// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo {\n  height: 40px;\n  width: 100px; }\n", "",{"version":3,"sources":["webpack://src/components/Logo/style.scss"],"names":[],"mappings":"AAAA;EACI,YAAY;EACZ,YAAY,EAAA","sourcesContent":[".logo{\n    height: 40px;\n    width: 100px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
